import { useCustomMutation } from "api/useCustomMutation";
import { JANZU_URL } from "config/config";

import { CachePolicy } from "../types";

// Interface for detector stats response
export interface DetectorStatsResponse {
  predictor: string;
  user: string;
  notes_reviewed: number;
}

// Hook for updating detector note/review stats
export const useUpdateDetectorNoteReview = (detectorId: string) =>
  useCustomMutation<DetectorStatsResponse, void>(
    `${JANZU_URL}reef-api/stats/user-detector?detector_id=${detectorId}`,
    "PATCH",
    {
      cachePolicy: CachePolicy.NO_CACHE,
    }
  );
